var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IndexWrapperSection',[_c('IndexHeading',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.$t('index.features.headline')))]),_c('ul',{staticClass:"list"},_vm._l((_vm.features),function(ref){
var title = ref.title;
var content = ref.content;
var img = ref.img;
var imgAlt = ref.imgAlt;
return _c('li',{staticClass:"item",style:({ "--icon": ("url(" + img + ")") }),attrs:{"role":"img","aria-label":imgAlt}},[_c('div',{staticClass:"flex flex-col items-stretch"},[_c('h3',{staticClass:"mb-2 text-lg lg:text-xl font-medium"},[_vm._v(_vm._s(title))]),_c('p',{staticClass:"text-neutral-600"},[_vm._v(_vm._s(content))])])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }